import {RegistrationInputField} from "./RegistrationInputField";
import * as validations from "./../../../utils/validate";

const emptyString = "";
const adultHoodAge = 18;

const defaultYearOfBirth = new Date().getFullYear() - adultHoodAge;

const defaultFirebaseMap = null;

const defaultFormFields = [
	new RegistrationInputField("name", emptyString, [validations.validateFieldIsRequired]),
	new RegistrationInputField("lastName", emptyString, [validations.validateFieldIsRequired]),
	new RegistrationInputField("yearOfBirth", defaultYearOfBirth, [validations.validateYearOfBirth]),
	new RegistrationInputField("phone", emptyString, [validations.validatePhone]),
	new RegistrationInputField("region", defaultFirebaseMap, [validations.validateFieldIsRequired]),
	new RegistrationInputField("city", defaultFirebaseMap, [validations.validateFieldIsRequired]),
	new RegistrationInputField("isCityInput", false),
	new RegistrationInputField("employment", emptyString, [validations.validateFieldIsRequired]),
	new RegistrationInputField("jobPosition", emptyString, [validations.validateFieldIsRequired]),
	new RegistrationInputField("class", emptyString),
	new RegistrationInputField("isClassTeacher", false),
	new RegistrationInputField("countOfStudents", 0),
	new RegistrationInputField("email", "", [validations.validateEmailField]),
	new RegistrationInputField("password", "", [validations.validatePasswordField]),
	new RegistrationInputField("personalData", false, [validations.validatePersonalData]),
	new RegistrationInputField("registrationDate", new Date().toISOString()),
];

export class RegistrationFormFields {
	/**
	 * Array of RegistrationInputField
	 */
	fields;

	constructor(fields) {
		this.fields = fields;
	}

	static DefaultInit = () => {
		return new RegistrationFormFields(defaultFormFields);
	}

	/**
	 * Reset all fields to default values
	 * Uses to set as React Component state.
	 * Therefore return a new form object.
	 * * @returns {any} New form Object
	 */
	reset = () => {
		this.fields.forEach(x => x.reset());
		return {
			...this
		};
	}

	/**
	 * Validate all fields in the form.
	 * Uses to set as React Component state.
	 * Therefore return a new form object.
	 * @returns {any} New form Object
	 */
	validate = () => {
		this.fields.forEach(x => x.validate());
		return {
			form: {
				...this
			},
			isValid: this.isValid()
		};
	}

	/**
	 * Validate required field and returns new form Object.
	 * Uses to set as React Component state.
	 * Therefore return a new form object.
	 * @param field Field to validate
	 * @returns {any} New form Object
	 */
	validateField = (field) => {
		field.validate();
		return {
			...this
		};
	}

	/**
	 * Find field by name
	 * @param fieldName
	 * @returns {*} field object of type RegistrationInputField
	 */
	find = (fieldName) => {
		return this.fields.filter(x => x.fieldName === fieldName)[0];
	}

	isValid = () => {
		return this.fields.every(x => x.isValid());
	}

	/**
	 * Updates required field and updates current form.
	 * Uses to set as React Component state.
	 * Therefore return a new form object.
	 * @param field Field to update
	 * @param newValue New field's value
	 * @returns {any} New form Object
	 */
	updateField = (field, newValue, shouldValidateAfterUpdate) => {
		field.value = newValue;
		if (shouldValidateAfterUpdate) {
			field.validate();
		}
		return {
			...this
		};
	}

	/**
	 * Reads all fields and creates new json Object
	 * @returns {{}} New json Object with form data
	 */
	formData = () => {
		const data = {};

		this.fields.forEach(x => {
			data[x.fieldName] = x.value;
		});

		return data;
	}

	setValidationsFor = (field, newValidations) => {
		field.setValidations(newValidations);
		return {
			...this
		};
	};
}